export const defaultGetId = <T>(t1: T): string => {
    if (typeof t1 === 'object' && t1 !== null && 'id' in t1) {
        return (t1 as { id: string }).id;
    }

    return t1 as string;
};
